
export default function Hero() {
  return (
    <section id="inicio" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img 
          src="https://readdy.ai/api/search-image?query=modern%20construction%20infrastructure%20project%20with%20large%20yellow%20cranes%20and%20heavy%20machinery%2C%20construction%20workers%20wearing%20hard%20hats%20and%20safety%20vests%2C%20architects%20and%20engineers%20reviewing%20blueprints%20on%20site%2C%20massive%20building%20under%20construction%20with%20steel%20structure%2C%20concrete%20foundations%2C%20dump%20trucks%20and%20excavators%20in%20background%2C%20golden%20hour%20lighting%2C%20professional%20wide%20angle%20photography%2C%20dramatic%20sky&width=1920&height=1080&seq=hero-construction-infra-002&orientation=landscape" 
          alt="Infraestructura de Construcción Ho Laasks" 
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center w-full">
        {/* Logo */}
        <div className="flex justify-center mb-8">
          <div className="bg-white/10 backdrop-blur-md rounded-2xl px-8 py-4 border border-white/20 inline-block">
            <img
              src="https://static.readdy.ai/image/207177310b9abd83a3c3d5d478fef01c/d22379a6088fe713bb5e26696f807d3b.png"
              alt="Ho Laasks Infraestructuras Logo"
              className="h-20 w-auto object-contain"
            />
          </div>
        </div>

        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight relative inline-block">
          <span className="relative z-10">Desarrollamos proyectos de construcción e infraestructura con altos estándares de calidad y profesionalismo.</span>
          <span className="absolute inset-0 -mx-4 -my-2 bg-black/20 backdrop-blur-sm rounded-2xl border border-white/10 z-0"></span>
        </h1>
        <p className="text-lg md:text-xl lg:text-2xl text-white/90 mb-8 max-w-3xl mx-auto">
          Nuestro compromiso es brindar soluciones eficientes y confiables mediante procesos bien estructurados y una ejecución precisa, asegurando obras sólidas y duraderas.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a 
            href="#servicios" 
            className="px-8 py-4 bg-teal-500 text-white rounded-full text-lg font-semibold hover:bg-teal-600 transition-all transform hover:scale-105 shadow-lg whitespace-nowrap"
          >
            Conocer Servicios
          </a>
          <a 
            href="#contacto" 
            className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white rounded-full text-lg font-semibold hover:bg-white/20 transition-all border-2 border-white/30 whitespace-nowrap"
          >
            Solicitar Demo
          </a>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          <div className="bg-white/10 backdrop-blur-md rounded-lg p-6 border border-white/20">
            <div className="w-12 h-12 flex items-center justify-center bg-teal-500 rounded-lg mb-4 mx-auto">
              <i className="ri-building-4-line text-2xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-white mb-2">Desarrollo de Obras de Infraestructura</h3>
            <p className="text-white/80 text-sm">Ejecutamos proyectos de infraestructura que contribuyen al crecimiento y modernización de los espacios urbanos, asegurando calidad estructural, funcionalidad y durabilidad en cada obra.</p>
          </div>
          <div className="bg-white/10 backdrop-blur-md rounded-lg p-6 border border-white/20">
            <div className="w-12 h-12 flex items-center justify-center bg-teal-500 rounded-lg mb-4 mx-auto">
              <i className="ri-hammer-line text-2xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-white mb-2">Construcción y Mejoramiento de Espacios</h3>
            <p className="text-white/80 text-sm">Desarrollamos y optimizamos espacios mediante procesos constructivos eficientes y el uso de materiales de alta calidad, garantizando resultados sólidos y confiables.</p>
          </div>
          <div className="bg-white/10 backdrop-blur-md rounded-lg p-6 border border-white/20">
            <div className="w-12 h-12 flex items-center justify-center bg-teal-500 rounded-lg mb-4 mx-auto">
              <i className="ri-pencil-ruler-2-line text-2xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-white mb-2">Planeación y Ejecución de Proyectos</h3>
            <p className="text-white/80 text-sm">Diseñamos y coordinamos proyectos desde su etapa inicial hasta su conclusión, cuidando cada detalle para asegurar cumplimiento en tiempos, costos y estándares de calidad.</p>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <a href="#servicios" className="text-white/70 hover:text-white transition-colors">
          <i className="ri-arrow-down-line text-3xl"></i>
        </a>
      </div>
    </section>
  );
}
